module.exports = __webpack_public_path__ + "static/media/riskVascularDisease.aafec007.mp3";